<!-- i18n -->
<template>
  <div class="changeLang-box">
    <el-dropdown trigger="click" @command="langChange">
      <span class="el-dropdown-link">
        <svg-icon icon-class="lang"/> {{$t('componentMsg.001')}} <i class="el-icon-arrow-down el-icon--right"></i></span>
            <template #dropdown>
           <el-dropdown-menu>
              <el-dropdown-item command="cn"
            >中文</el-dropdown-item>
              <el-dropdown-item command="en">English</el-dropdown-item>
             </el-dropdown-menu>
          </template>
       </el-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      language:localStorage.getItem("language") ||'cn', // 读取本地存储，如果没有则默认设置为'en'
    };
  },
  created() {
    // 组件创建时设置i18n的locale
    this.$i18n.locale = this.language;
  },
  methods: {
    //语言切换
    langChange(e) {
      localStorage.setItem("language", e);
      this.language = e;
      this.$i18n.locale = e;
    },
  },
};
</script>
<style lang="less" scoped>
.changeLang-box{
  color: white;
}
.el-dropdown{
  color: white;
  font-size: 16px;
}
</style>
